// Import components
import CartItem from './CartItem/CartItem';

// Import types
import type { CurrentProduct as CurrentProductType } from 'types/api/packetsSubscription/details';
import type { PacketSubtype } from 'types/api/products/product';

type Props = {
	product: CurrentProductType;
	subtype: PacketSubtype;
	isRemoved?: boolean;
};

export const CurrentProduct = ({ product: { product_uuid, name, price }, subtype, isRemoved = false }: Props) => (
	<CartItem
		isRemoved={isRemoved}
		product={{
			subtype,
			title: name,
			standard_price: price,
			current_price: price,
			uuid: product_uuid,
			promotion: null
		}}
	/>
);
